import { claimMap } from '..';
import { ClaimInfo, UsersClaims } from '../types';

const ptBR: Record<UsersClaims, { title: string; description: string }> = {
  [UsersClaims.OFFICE_CREDITORS_VIEW]: {
    title: 'Ver resultado de todos os usuários',
    description: 'Permite a visualização de todos os usuários na empresa',
  },
  [UsersClaims.CUSTOMIZED_TABLE]: {
    title: 'Tabela personalizada na página inicial',
    description: 'Mostra uma tabela personalizada na página inicial no lugar da tabela padrão',
  },
  [UsersClaims.TEAM_CREDITORS_VIEW]: {
    title: 'Ver usuários do time',
    description: 'Permite a visualização de usuários dos próprios times',
  },
  [UsersClaims.CLOSURE_UNFINISHED_VIEW]: {
    title: 'Visualizar fechamentos inacabados',
    description: 'Permite visualizar os fechamentos inacabados',
  },
  [UsersClaims.CLOSURE_UPDATE]: {
    title: 'Atualizar fechamentos',
    description: 'Permite atualizar/visualizar fechamentos',
  },
  [UsersClaims.USER_CREATE]: {
    title: 'Criar usuários',
    description: 'Permite a criação de usuários',
  },
  [UsersClaims.PAYROLL_VIEW]: {
    title: 'Visualizar folha de pagamento',
    description: 'Permite a visualização da folha de pagamento',
  },
  [UsersClaims.PAYSLIP_VIEW]: {
    title: 'Visualizar resumo de valores repassados/recebidos',
    description: 'Permite a visualizar resumo de valores repassados/recebidos',
  },
  [UsersClaims.PERMISSION_PAYMENTS]: {
    title: 'Permissão de pagamentos',
    description: 'Concede permissão para realizar pagamentos',
  },
  [UsersClaims.BACKOFFICE]: {
    title: 'Permissão de backoffice',
    description: 'Concede permissão para realizar ações backoffice',
  },
  [UsersClaims.MIGRATION_UNION_V2]: {
    title: 'Permissão para migrar para nova experiência de União',
    description: 'Concede permissão para migrar para nova experiência de União',
  },
  [UsersClaims.FEATURE_USER_AMOUNT_AGREEMENT]: {
    title: 'Aceite de valores do usuário',
    description: 'Habilita funcionalidade de aceitar/discordar/questionar valores recebidos',
  },
  [UsersClaims.FEATURE_GOALS_CONFIG]: {
    title: 'Configuração de metas',
    description: 'Habilita funcionalidade de configuração de metas dentro do fechamento',
  },
  [UsersClaims.FEATURE_SEE_OWNED_COMMISSIONS]: {
    title: 'Visualizar comissões em que sou dono',
    description:
      'Habilita visualização de comissões em que o usuário é dono (mesmo quando não recebe nenhuma parte)',
  },
  [UsersClaims.CUSTOM_REPORTS]: {
    title: 'Relatórios personalizados',
    description: 'Configuração de relatórios personalizados',
  },

  [UsersClaims.ADJUSTMENT_REQUEST_VIEW]: {
    title: 'Tela de pedidos de ajustes',
    description: 'Habilita tela de pedidos de ajustes (lideres para pedir, admins para aprovar)',
  },
  [UsersClaims.SHEET_DATA_SOURCE]: {
    title: 'Google sheets como fonte de dados no fechamento',
    description: 'Habilita opção de importar Google sheets diretamente no fechamento',
  },
  [UsersClaims.FEATURE_VARIABLES]: {
    title: 'Variáveis',
    description:
      'Habilita páginas de edição de variáveis (dentro do fechamento, e no menu lateral)',
  },
  [UsersClaims.UNCAPPED_RULES]: {
    title: 'Regras com porcentagem sem teto',
    description: 'Habilita o uso de regras sem teto (porcentagens maiores que 100%)',
  },
  [UsersClaims.FEATURE_TEAM_VARIABLES_VIEW]: {
    title: 'Visualizar variáveis do time',
    description:
      'Habilita líderes de times a visualizar variáveis dos membros dos times (acesso via tela inicial)',
  },
  [UsersClaims.USER_MESSAGES]: {
    title: 'Mensagens aos usuários',
    description: 'Configuração de mensagens aos usuários (exibidas na tela inicial)',
  },
  [UsersClaims.TEAMS_VIEW_PERMISSION]: {
    title: 'Times que posso ver',
    description:
      'Concede a permissão de visualização de usuários (e seus resultados) de times específicos',
  },
  [UsersClaims.CREDITORS_VIEW_PERMISSION]: {
    title: 'Pessoas que posso ver',
    description: 'Concede a permissão de visualização de usuários (e seus resultados) específicos',
  },
  [UsersClaims.DETAILSTABLE_HIDDEN_COLUMNS]: {
    title: 'Esconder colunas da tabela de detalhes',
    description:
      'Esconde colunas específicas da tabela de detalhes (tabela padrão da página inicial)',
  },
  [UsersClaims.HIDE_DIVISION_DETAILS]: {
    title: 'Esconder detalhes de divisão',
    description: 'Esconde detalhes de divisão da página inicial (tabela default e personalizada)',
  },
  [UsersClaims.FEATURE_CREDITOR_NAME_ON_RULES]: {
    title: 'Nome do usuário nas regras',
    description: 'Habilita um autocompletar com os nomes dos usuários para preencher regras',
  },
  [UsersClaims.OFFICE_LOGO_URL]: {
    title: 'Logo da empresa',
    description: 'URL pública com uma imagem para o logo da empresa',
  },
  [UsersClaims.CREDITOR_REPORT_ROA_VIEW]: {
    title: 'Visualização de ROA nos relatórios de usuários',
    description: 'Habilita visualização de ROA nos relatórios individuais de usuários',
  },
  [UsersClaims.ALL_COMMISSIONS_TABLE]: {
    title: 'Tabela com todas as comissões',
    description:
      'Habilita página com tabela de todas as comissões (detalhes de comissões e divisões)',
  },
  [UsersClaims.GROSS_COMMISSION_AMOUNT]: {
    title: 'Habilita sumarização de valores brutos',
    description: 'Habilita sumarização da coluna valores brutos na tabela da página inicial',
  },
  [UsersClaims.EXPORT_ARBITRARY_FIELDS]: {
    title: 'Exportar campos arbitrários',
    description: 'Permite visualizar campos arbitrários exportados',
  },
  [UsersClaims.USER_PREFERENCES]: {
    title: 'Preferências do usuário',
    description: 'Mantem a data, esconder valores e o estado do menu que o usuário deixou',
  },
  [UsersClaims.THEME_CONFIG]: {
    title: 'Configuração de tema',
    description: 'Configura tema (claro ou escuro) e cores gerais do sistema',
  },
  [UsersClaims.GENERIC_DATA_IMPORT]: {
    title: 'Fonte de dados',
    description: 'Habilita a página de Fonte de dados',
  },

  [UsersClaims.DOCUMENT_MANAGEMENT]: {
    title: 'Gerenciar documentos',
    description: 'Habilita página de gestão de documentos',
  },
  [UsersClaims.COMPANY_MANAGEMENT]: {
    title: 'Gerenciar empresas',
    description: 'Habilita página de gestão de empresas',
  },
  [UsersClaims.APPLY_RULES_FUTURE_CLOSURES]: {
    title: 'Aplicar regras em fechamentos futuros',
    description:
      'Habilita opção de aplicar regras em fechamentos futuros (quando aplicando uma regra de fechamento)',
  },
  [UsersClaims.NOTIFY_ANSWERED_QUESTION]: {
    title: 'Notificar pergunta respondida',
    description:
      'Habilita notificação quando uma pergunta é respondida (deve ser usado junto com feature.user.amount.agreement)',
  },
  [UsersClaims.NOTIFY_QUESTIONED]: {
    title: 'Notificar questionado',
    description:
      'Habilita notificação quando uma nova pergunta é feita (deve ser usado junto com feature.user.amount.agreement)',
  },
  [UsersClaims.NOTIFY_PAYMENT_RECEIVED]: {
    title: 'Notificar usuário de pagamento recebido',
    description: 'Habilita notificação quando um pagamento é recebido (notifica usuário pago)',
  },
  [UsersClaims.DISABLE_SPLITC_REFERRAL]: {
    title: 'Desabilita referencia à Splitc',
    description: 'Desabilita referencia à Splitc',
  },
  [UsersClaims.OFFICE_SSO_CONFIG]: {
    title: 'Configuração de SSO da empresa',
    description: 'Configuração de SSO da empresa',
  },
  [UsersClaims.XP_INTEGRATION_CONFIG]: {
    title: 'Configuração da integração XP API',
    description: 'Configuração da integração XP API',
  },
  [UsersClaims.DISABLE_ALL_COMMISSIONS_TABLE]: {
    title: 'Desabilitar tabela com todas as comissões',
    description: 'Desabilita a tabela com todas as comissões (detalhes de comissões e divisões)',
  },
  [UsersClaims.DISABLE_HOME_MONTH_EARNING]: {
    title: 'Desabilitar ganhos na página inicial',
    description: 'Desabilitar o "olho" de ganho mensal na home',
  },
  [UsersClaims.GOAL_APPEARANCE_CONFIG]: {
    title: 'Configuração da aparência de metas',
    description: 'Configuração da aparência de metas na página inicial',
  },
  [UsersClaims.MANAGE_PERMISSION_PROFILES]: {
    title: 'Gerenciar perfis de permissão',
    description: 'Habilita tela de gestão de perfis de permissão',
  },
  [UsersClaims.MANAGE_OFFICE_PERMISSIONS]: {
    title: 'Gerenciar permissões gerais',
    description: 'Gerenciar as permissões para todos os usuários',
  },
  [UsersClaims.OFFICE_LOGIN_CONFIG]: {
    title: 'Configuração de política de login',
    description:
      'Configurações usadas para forçar rotação de senha e outras configurações de login',
  },
  [UsersClaims.HIDE_REPORTS]: {
    title: 'Ocultar relatórios',
    description: 'Desabilita a visualização de relatórios',
  },
  [UsersClaims.HIDE_SPLITC_LOGO]: {
    title: 'Ocultar logo da SplitC',
    description: 'Oculta o logo da SplitC no menu',
  },
  [UsersClaims.HIDE_LOGOUT]: {
    title: 'Ocultar logout',
    description: 'Remove a opção de logout do menu',
  },
  [UsersClaims.FEATURE_DIVISION_ROUNDING]: {
    title: 'Arredondamento de divisões',
    description: 'Configuração de arredondamento das divisões',
  },
  [UsersClaims.FEATURE_INACTIVITY_LOGOUT]: {
    title: 'Logout por inatividade',
    description: 'Configuração de logout por inatividade',
  },
  [UsersClaims.STATEMENT_PANEL_VISIBLE]: {
    title: 'Habilitar o dashboard',
    description: 'Permite visualizar e interagir com o editor de dashboard',
  },
  [UsersClaims.UPSERT_CUSTOMERS_NAME]: {
    title: 'Renomear clientes',
    description: 'Permite editar o nome dos clientes',
  },
  [UsersClaims.CREDITOR_PAYMENT_INFO_VIEW]: {
    title: 'Visualizar informações de pagamento dos usuários',
    description: 'Habilita a visualização de informações de pagamento dos usuários',
  },
  [UsersClaims.CREDITOR_PAYMENT_INFO_WRITE]: {
    title: 'Gerenciar informações de pagamento dos usuários',
    description: 'Habilita o gerenciamento de informações de pagamento dos usuários',
  },
  [UsersClaims.INQUIRIES_MANAGEMENT]: {
    title: 'Gerenciar chamados dos planos de cálculos',
    description: 'Habilitar gerenciamento de chamados dos planos de cálculos',
  },
  [UsersClaims.HIDE_OLD_HOME]: {
    title: 'Esconder a antiga página inicial',
    description: 'Esconder e prevenir acesso à antiga página inicial',
  },
  [UsersClaims.ALLOW_USER_IMPERSONATION]: {
    title: 'Permitir personificar outros usuários',
    description: 'Permite o usuário de copiar acessos de usuários que ele tem permissão de ver',
  },
  [UsersClaims.PREVENT_USER_DELETION]: {
    title: 'Não permitir exclusão usuários',
    description: 'Previne que os usuários sejam excluídos',
  },
  [UsersClaims.FEATURE_PAYROLL_V2]: {
    title: 'Nova folha de pagamentos',
    description: 'Habilita nova folha de pagamentos',
  },
  [UsersClaims.CLOSURE_SHOW_HIDDEN_MESSAGE]: {
    title: 'Mensagem de fechamentos ocultos',
    description: 'Mensagem para fechamentos não liberados',
  },
  [UsersClaims.PAYROLL_STATUS_MANAGER]: {
    title: 'Gerenciador de Status da Folha de Pagamentos',
    description:
      'Pode configurar o fluxo e as permissões para atualizações de status na folha de pagamentos',
  },
  [UsersClaims.USER_MANAGEMENT]: {
    title: 'Gestão de usuários',
    description:
      'Pode editar usuários que possui acesso, podendo criar e/ou excluir. Incluir em times e/ou perfis',
  },
  [UsersClaims.AUTOMATIC_BACKUP_CLOSURES]: {
    title: 'Backup Automático dos fechamentos',
    description:
      'Habilita backup automático dos fechamentos após alterações(aplicar regras, troca de campos)',
  },
  [UsersClaims.PLAN_GROUP_PERMISSIONS]: {
    title: 'Permissões granulares de planos de cálculos',
    description:
      'Permite a configuração de permissões granulares para planos de cálculos específicos',
  },
  [UsersClaims.REQUIRED_INQUIRY_TAG]: {
    title: 'Categorização de chamados obrigatória',
    description:
      'Torna a seleção de uma categoria obrigatória para criar um chamado',
  },
};

function mergeClaimMapWithTranslation<T extends object>(
  translationsObj: T,
): Record<UsersClaims, ClaimInfo> {
  const newClaimMap = {} as Record<UsersClaims, ClaimInfo>;

  Object.entries(claimMap).forEach(([key, value]) => {
    const typedKey = key as keyof typeof translationsObj;
    const newClaimMapTypedKey = key as keyof typeof newClaimMap;

    if (translationsObj[typedKey]) {
      newClaimMap[newClaimMapTypedKey] = {
        ...value,
        ...translationsObj[typedKey],
      };

      return;
    }

    newClaimMap[newClaimMapTypedKey] = value;
  });

  return newClaimMap;
}

export function getTranslatedClaims(
  locale: 'ptBR' | 'enUS' = 'enUS',
): Record<UsersClaims, ClaimInfo> {
  if (locale === 'ptBR') {
    return mergeClaimMapWithTranslation(ptBR);
  }

  return claimMap;
}
